<div class="modol_comp">
    <div class="modal-header pb-0 pt-0">
        <div>
            <button class="button-close" mat-button [mat-dialog-close]="false">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
                </svg>
            </button>
        </div>
    </div>
    <div class="modal-body pt-0">
        <h2> {{data?.heading }}</h2>
        <form class="" [formGroup]="updateClientForm">
            <div class="row">

                <div class="form-group col-md-6">
                    <label class="">Payment Mode</label>
                    <mat-select class="form-control mt-3" formControlName="paymentMode" #payment
                        (selectionChange)="isOnline($event)"
                        [ngClass]="{ 'is-invalid': submitted && f['paymentMode'].errors}"
                        placeholder="Select Payment Mode">
                        <mat-option *ngFor="let mode of paymentModeArray"
                            [value]="mode?.value">{{mode.type}}</mat-option>
                    </mat-select>
                    <div *ngIf=" submitted && f['paymentMode'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['paymentMode'].errors['required']"> Payment Mode is required. </div>
                    </div>
                </div>
                <div class="form-group col-md-6">
                    <label class="">Start Date</label>
                    <div class="date mt-3" [ngClass]="{ 'is-invalid': submitted && f['startDate'].errors}">
                        <input type="text" matInput [min]="todayDate" [matDatepicker]="dp2" (click)="dp2.open()"
                            [disabled]="true" readonly placeholder="MMM DD, YYYY" formControlName='startDate'>
                        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                        <mat-datepicker #dp2></mat-datepicker>
                    </div>
                    <div *ngIf=" submitted && f['startDate'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['startDate'].errors['required']">
                            {{validationErrorMessage.date}}
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-12">
                    <label class="">Subscription Package</label>
                    <mat-select class="form-control mt-3" formControlName="package"
                        (selectionChange)="setAmount($event)"
                        [ngClass]="{ 'is-invalid': submitted && f['package'].errors}" placeholder="Select Package">
                        <mat-option *ngFor="let mode of packageList"
                            [value]="mode?._id">{{mode?.packageName}}</mat-option>
                    </mat-select>
                    <div *ngIf=" submitted && f['package'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['package'].errors['required']"> Subscription Plan is required. </div>
                    </div>
                </div>

                <!-- Number of trucks -->
                <div class="form-group col-md-12">
                    <label class=""># of trucks</label>
                    <input type="number" class="form-control mt-3" formControlName="numberOfTrucks" min="1"
                        [max]="maxTrucks" maxlength="2" (input)="limitInput($event)"
                        [ngClass]="{ 'is-invalid': submitted && f['numberOfTrucks'].errors}"
                        placeholder="Enter Number on Trucks" />
                    <div *ngIf=" submitted && f['numberOfTrucks'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['numberOfTrucks'].errors['required']">
                            please enter how many trucks you would like to schedule
                        </div>
                        <div *ngIf="submitted && f['numberOfTrucks'].errors?.['min']" class="text-danger">
                            Minimum value allowed is 1
                        </div>

                        <div *ngIf="submitted && f['numberOfTrucks'].errors?.['max']" class="text-danger">
                            Maximum value allowed is {{maxTrucks}}
                        </div>
                    </div>
                </div>
                <!-- Number Of trucks -->

                <!-- ADD ONS -->
                <div class="form-group col-md-12">
                    <label class="">Add-Ons</label>

                    <mat-select class="form-control mt-3" formControlName="addOns" multiple
                        (selectionChange)="setAddOns($event)"
                        [ngClass]="{ 'is-invalid': submitted && f['addOns'].errors }" placeholder="Select Add-Ons">
                        <mat-option *ngFor="let add of AddOnsArray" [value]="add.value">
                            {{ add.type }}
                        </mat-option>
                    </mat-select>

                    <div *ngIf="submitted && f['addOns'].errors" class="invalid-feedback">
                        <div *ngIf="f['addOns'].errors['required']">
                            At least one Add-On is required.
                        </div>
                    </div>
                </div>
                <!-- ADDS ONS -->

                <div class="form-group col-md-12">
                    <div class="dollar">
                        <span class="">$</span>
                        <label class="">Subscription Payment Received</label>
                        <input type="number" class="form-control mt-3" formControlName="amount"
                            (keydown.space)="$event.preventDefault()"
                            (keypress)="validationService.numberWithDecimal($event)" (blur)="setTodecimal()"
                            [ngClass]="{ 'is-invalid': submitted && f['amount'].errors}" placeholder="Enter amount" />
                    </div>
                    <div *ngIf=" submitted && f['amount'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['amount'].errors['required']">
                            Subscription Payment is required
                        </div>
                    </div>
                </div>

            </div>
        </form>
    </div>
    <div class="modal-footer d-flex justify-content-between mt-3">
        <button type="submit" class="btn" (click)="addClient()">Update Subscription</button>

    </div>

</div>